<mat-tree
  class="adf-tree-view-media"
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  *ngIf="nodeId; else missingNodeId"
>
  <mat-tree-node
    class="adf-tree-view-node"
    *matTreeNodeDef="let treeNode"
    id="{{ treeNode.name + '-tree-node' }}"
    matTreeNodePadding
    [matTreeNodePaddingIndent]="15"
  >
    {{ treeNode.name }}
  </mat-tree-node>
  <mat-tree-node
    class="adf-tree-view-node"
    id="{{ 'node-' + treeNode.nodeId + '-tree-child-node' }}"
    *matTreeNodeDef="let treeNode; when: hasChild"
    [ngClass]="{
      'adf-tree-view-node-file': treeNode.node.entry.isFile,
      'selected-node':
        treeControl.isExpanded(treeNode) && !treeNode.node.entry.isFile
    }"
    [ngStyle]="{
      display: !treeNode.node.entry.isFile
        ? 'flex'
        : mediaType === 'audio' || mediaType === 'application|text'
        ? 'block'
        : 'inline-flex',
      width: !treeNode.node.entry.isFile
        ? 'auto'
        : mediaType === 'audio' || mediaType === 'application|text'
        ? '100%'
        : '200px',
      'border-bottom': !treeNode.node.entry.isFile
        ? '1px solid #DADADA'
        : 'none'
    }"
    matTreeNodePadding
    [matTreeNodePaddingIndent]="15"
  >
    <ng-container *ngIf="!treeNode.node.entry.isFile">
      <button
        id="{{ 'button-' + treeNode.nodeId }}"
        mat-icon-button
        [attr.aria-label]="'toggle ' + treeNode.filename"
        matTreeNodeToggle
        [ngClass]="{
          'selected-node-folder':
            treeControl.isExpanded(treeNode) && !treeNode.node.entry.isFile
        }"
        (click)="logTreeControl($event, treeNode.node)"
        (keyup.enter)="logTreeControl($event, treeNode.node)"
      >
        <span
          *ngIf="treeControl.isExpanded(treeNode)"
          class="wk-icon-folder-open folder"
        >
        </span>
        <span
          *ngIf="treeControl.isExpanded(treeNode)"
          class="wk-icon-chevron-down arrow"
        >
        </span>
        <span
          *ngIf="
            !treeControl.isExpanded(treeNode) && !treeNode.node.entry.isFile
          "
          class="wk-icon-folder folder"
        >
        </span>
        <span
          *ngIf="
            !treeControl.isExpanded(treeNode) && !treeNode.node.entry.isFile
          "
          class="wk-icon-chevron-right arrow"
        >
        </span>
        <div class="adf-tree-view-label">
          {{ treeNode.name }}
        </div>
      </button>
    </ng-container>
    <ng-container *ngIf="treeNode.node.entry.isFile">
      <div class="parent-wrapper">
        <div class="parent">
          <div
            class="child"
            [ngClass]="{
              'child-then-audio':
                mediaType === 'audio' || mediaType === 'application|text'
            }"
          >
            <button
              id="{{ 'button-' + treeNode.nodeId }}"
              mat-icon-button
              [attr.aria-label]="'toggle ' + treeNode.filename"
              matTreeNodeToggle
              (click)="onNodeClicked($event, treeNode.node)"
              (keyup.enter)="onNodeClicked($event, treeNode.node)"
            >
              <ng-container *ngIf="mediaType === 'image'">
                <img
                  class="tree-image-node"
                  [src]="getMediaSource(treeNode.node.entry.id)"
                  [alt]="treeNode.name"
                />
              </ng-container>
              <ng-container *ngIf="mediaType === 'audio'">
                <div>
                  <span
                    *ngIf="!treeNode.node?.isPlay"
                    (click)="onPlay($event, treeNode.node)"
                    (keyup)="onPlay($event, treeNode.node)"
                    class="wk-icon-filled-play"
                  ></span>
                  <span
                    *ngIf="treeNode.node?.isPlay"
                    (click)="onPause($event, treeNode.node)"
                    (keyup)="onPause($event, treeNode.node)"
                    class="wk-icon-filled-pause"
                  ></span>
                  <div class="adf-tree-view-label">
                    {{ treeNode.name }}
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="mediaType === 'video'">
                <div class="video">
                  <video class="tree-video-node" controls preload="none" [poster]="getPoster(treeNode.node.entry.properties['apollo:tenantId'])">
                    <source [src]="getMediaSource(treeNode.node.entry.id)" />
                    {{
                      'APP.MESSAGES.ERRORS.BROWSER_NOT_SUPPORT_VIDEO'
                        | translate
                    }}
                    <source src="" type="video/webm" />
                    <track
                      label="English"
                      kind="captions"
                      srclang="en"
                      src=""
                      default
                    />
                  </video>
                </div>
              </ng-container>
              <ng-container *ngIf="mediaType === 'application|text'">
                <span class="file wk-icon-file"></span>
                <div
                  [ngStyle]="{ 'margin-top': 0 }"
                  class="adf-tree-view-label"
                >
                  {{ treeNode.name }}
                </div>
              </ng-container>
              <img
                src="assets/images/document-view-details.png"
                [title]="'APP.ACTIONS.DETAILS' | translate"
                (click)="onPreviewClicked($event)"
                (keyup)="onPreviewClicked($event)"
                *ngIf="mediaType === 'image'"
                class="wk-preview-icon"
                [alt]="'APP.ACTIONS.DETAILS' | translate"
              />
            </button>
            <div
              *ngIf="mediaType !== 'audio' && mediaType !== 'application|text'"
              (click)="onNodeClicked($event, treeNode.node)"
              (keyup)="onNodeClicked($event, treeNode.node)"
              class="adf-tree-view-title"
            >
              {{ treeNode.name }}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </mat-tree-node>
</mat-tree>
<ng-template #missingNodeId>
  <div id="adf-tree-view-missing-node">
    {{ 'ADF-TREE-VIEW.MISSING-ID' | translate }}
  </div>
</ng-template>
